import React from "react";
import { calculateDaysRemaining } from "../../../../../shared/utils/function";
import { useNavigation } from "../../../../../shared/utils/useNavigation";
import SubscribeModalLoggedIn from "../../../../Modals/SubscribeModal/SubscribeModalLoggedIn";
import { PURCHASE_STATE } from "../../../../../shared/constants/common";
import "./ExpiryList.css";

const ExpiryList = ({
  expiringSoonList = [],
  onSubscriptionSuccess,
}) => {
  const navigate = useNavigation();

  const handleProfileClick = (username) => {
    navigate.toProfile(username);
  };

  return (
    <section className="renewal-reminders">
      <div className="reminders-header">
        <div className="reminders-title">
          <i className="fa-solid fa-clock reminder-clock-icon"></i>
          <h3>Expiration Reminders</h3>
        </div>
      </div>

      <div className="reminders-list">
        {expiringSoonList && expiringSoonList.length > 0 ? (
          expiringSoonList.map((item) => {
            let daysRemaining = calculateDaysRemaining(item.expire_at);
            if (daysRemaining === 0) {
              daysRemaining = 1;
            }

            const isActive = item.state === PURCHASE_STATE.ACTIVE; // Active subscription (never unsubscribed)

            // Determine severity class: red for 1-2 sodays, yellow for 3-7 days
            let severityClass = '';

            if (isActive) { //  || daysRemaining > 7
              severityClass = 'active';
            } else if (daysRemaining >= 0 && daysRemaining <= 2) {
              severityClass = 'urgent'; // Red tile
            } else if (daysRemaining >= 3 && daysRemaining <= 7) {
              severityClass = 'expiring-soon'; // Yellow tile
            } else {
              severityClass = 'expiring-soon'; // Default to yellow for other cases
            }

            const expireDate = new Date(item.expire_at);
            const formattedDate = expireDate.toLocaleDateString(undefined, {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            });

            return (
              <div key={item._id} className={`reminder-item ${severityClass} renewal_reminders_item`}>
                <div className="reminder-content">
                  <div className={`reminder-icon ${severityClass === 'urgent' ? 'red-warning' :
                    severityClass === 'active' ? 'green-warning' :
                      'yellow-warning'
                    }`}>
                    <i className="fa-solid fa-exclamation-triangle"></i>
                  </div>
                  <div className="reminder-text">
                    <div className="reminder-title">
                      <span
                        className="reminder-title-username cursor-pointer"
                        onClick={() => handleProfileClick(item.username)}
                      >
                        @{item.username} {' '}
                      </span>
                      {isActive && daysRemaining > 0 ? (
                        <span>
                          Renews {formattedDate}
                        </span>
                      ) : daysRemaining < 0 ? (
                        <>
                          <span className="reminder-title-expired">Expired</span>
                        </>
                      ) : (
                        <>
                          expires in {daysRemaining} day{daysRemaining === 1 ? '' : 's'}
                        </>
                      )}
                    </div>
                    {!isActive && (
                      <div className="reminder-date">{formattedDate}</div>
                    )}
                  </div>
                </div>
                <SubscribeModalLoggedIn
                  creatorInfo={item.creatorInfo}
                  isRenew={true}
                  btnText="Renew"
                  isButtonClickable={true}
                  handleCallback={onSubscriptionSuccess}
                />
              </div>
            );
          })
        ) : (
          <div className="no-content">
            <p>No upcoming expirations</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default ExpiryList;

